import React from 'react'
import { useOrderListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable, LoadingTableStats, RefreshableTableStat, RowCountTableStats } from '@ztechapps/webui.data-tools'
import { orderListFieldConfig as fieldsCore } from './constants'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import { HorizontalStack } from '@ztechapps/webui.util'
import { formatMoney } from '@ztechapps/common.utils'
import type { SetOptional } from 'type-fest'
import type { Order } from '@ztechapps/common.contract'

export const OrderList = ({
  stats,
  row,
  head,
  fields,
  listResult,
  tableOptions,
  ...props
}: SetOptional<DataTableProps<Order>, 'listResult' | 'fields'>) => {
  const { orderList, orderListWithSelection } = useOrderListContext()
  const { list } = orderListWithSelection
  const defaultListResult = { ...orderList, list }
  return (
    <DataTable
      {...props}
      fields={fields ?? fieldsCore}
      listResult={listResult ?? defaultListResult}
      row={row ?? ListRow}
      head={head ?? ListHeader}
      stats={stats ?? <Stats />}
      tableOptions={{
        ...tableOptions,
        responsive: true,
      }}
    />
  )
}

export const Stats = () => {
  const { orderList } = useOrderListContext()

  if (orderList?.loading) return <LoadingTableStats />

  return (
    <HorizontalStack gap={3}>
      <RowCountTableStats label="order" />
      <TotalNetTableStats />
    </HorizontalStack>
  )
}

const TotalNetTableStats = () => {
  const { getNetTotalResult } = useOrderListContext()
  const { document: netTotal, loading, refetch } = getNetTotalResult

  return (
    <RefreshableTableStat
      label="Total of net:"
      value={formatMoney(netTotal)}
      loading={loading}
      onRefresh={() => refetch()}
      busyText="Calculating the total..."
      className="fw-bold text-decoration-none"
    />
  )
}
